import axios from "axios";
import { authHeader, multipartHeader } from "./auth-header";

const getAll = (roleId, keyword, page, perPage, excludeId, filterUser, all, active) => {
  return axios.get(process.env.REACT_APP_API_URL + "users/list", {
    headers: authHeader(),
    data: {},
    params: {
      roleId: roleId,
      keyword: keyword,
      page: page,
      perPage: perPage,
      excludeId: excludeId,
      filterUser,
      all,
      active
    },
  });
};

const getAllUsers = (keyword, page, perPage, all) => {
  return axios.get(process.env.REACT_APP_API_URL + "users/getAllListing", {
    headers: authHeader(),
    data: {},
    params: {
      keyword: keyword,
      page: page,
      perPage: perPage,
      all,
    },
  });
};

const get = (id) => {
  return axios.get(process.env.REACT_APP_API_URL + `user/view`, {
    headers: authHeader(),
    data: {},
    params: {
      userId: id,
    },
  });
};

const create = (data) => {
  return axios.post(process.env.REACT_APP_API_URL + `user/create`, data, {
    headers: multipartHeader(),
  });
};

const update = (id, data) => {
  return axios.put(process.env.REACT_APP_API_URL + `user/update/${id}`, data, {
    headers: multipartHeader(),
  });
};

const updateStatus = (id, data) => {
  return axios.put(
    process.env.REACT_APP_API_URL + `user/updateStatus/${id}`, data,
    {
      headers: authHeader(),
    }
  );
};

const verifyUserTaxInfo = (id, data) => {
  return axios.put(
    process.env.REACT_APP_API_URL + `user/verifyUserTaxInfo/${id}`,
    data,
    {
      headers: authHeader(),
    }
  );
};

const deleteUser = (id, data) => {
  return axios.delete(process.env.REACT_APP_API_URL + `user/delete/${id}`, {
    headers: authHeader(),
    data,
  });
};

const restore = (id, data) => {
  return axios.get(process.env.REACT_APP_API_URL + `user/restore/${id}`, {
    headers: authHeader(),
    params: data
  });
};

const verifyUser = (id) => {
  return axios.put(
    process.env.REACT_APP_API_URL + `user/verifyUser/${id}`,
    {},
    {
      headers: authHeader(),
    }
  );
};

const exportUser = () => {
  return axios.get(process.env.REACT_APP_API_URL + `user/admin/export`, {
    headers: authHeader(),
    responseType: "blob"
  });
}

const getPartnerAgreements = (userId, page = 1, perPage = 10) => {
  return axios.get(
    process.env.REACT_APP_API_URL + `users/${userId}/partner-agreements`,
    {
      headers: authHeader(),
      params: {
        page,
        perPage,
      },
    }
  );
};

const downloadPartnerAgreement = (agreementId) => {
  return axios.get(
    process.env.REACT_APP_API_URL + `partner-agreements/${agreementId}/download`,
    {
      headers: authHeader(),
      responseType: "blob",
    }
  );
};

const getUserVehicles = (userId) => {
  return axios.get(process.env.REACT_APP_API_URL + `user/admin/vehicles`, {
    headers: authHeader(),
    params: {
        userId
    }
  });
}

const searchCSR = (keyword = "") => {
  return axios.get(
    process.env.REACT_APP_API_URL + "user/admin/csr/search",
    {
      headers: authHeader(),
      params: {
        keyword,
      },
    }
  );
};

// Retrieve a host's connected Stripe account details by account id.
const getStripeAccount = (accountId) => {
  return axios.post(
    process.env.REACT_APP_API_URL + "user/stripeAccount",
    { accountId: accountId || null },
    {
      headers: authHeader(),
    }
  );
};

export default {
  getAll,
  get,
  create,
  update,
  updateStatus,
  verifyUserTaxInfo,
  deleteUser,
  restore,
  verifyUser,
  exportUser,
  getPartnerAgreements,
  downloadPartnerAgreement,
  getUserVehicles,
  getAllUsers,
  searchCSR,
  getStripeAccount
};
